// extracted by mini-css-extract-plugin
export var wordContainer = "_ml-0";